var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daqi-copyright"},[_c('img',{attrs:{"src":require("@/assets/images/daqi-copyright.png")}}),_c('span',[_vm._v("大旗软件提供技术支持")])])}]

export { render, staticRenderFns }